import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_URL } from '../../api/ApiSettings';
import * as errorSlice from '../error/errorSlice';

const initialState = {
    buildingNumber:'',
    city:'',
    id:0,
    companyName:'', 
    companyTax: '',
    country:'PL', 
    email:'',
    flatNumber:'',
    fullStreet:'',
    name:'',
    surname:'',
    newCustomer: false,
    phone:'',
    phoneCode:'',
    postalCode:'',
    street:'',
    type:{
      id:0,
      displayName: '',
      customerType: '',
      description: '',
      value:''
    },
      
};

// definicja działania asynchronicznego do pobrania danych klienta
export const getCustomer = createAsyncThunk('customer/getCustomersTypes', async (_, { rejectWithValue, dispatch })  => {
  try{

    const response = await fetch(`${API_URL}complaint/getCustomerComplaintTypes`);
    const data = await response.json(); 
    const customerId = data.map(customer => customer)
    if (response.status === 200) {
        return customerId;
      } else {
        console.error("Błąd pobierania typów reklamacji dla klienta");
        dispatch(errorSlice.setError("Błąd pobierania typów reklamacji dla klienta"));
        return rejectWithValue("Błąd pobierania typów reklamacji dla klienta");
      }
  
    } catch (error) {
      console.error("Błąd pobierania typów reklamacji dla klienta:", error);
      dispatch(errorSlice.setError("Błąd pobierania typów reklamacji dla klienta"));
      return rejectWithValue("Błąd pobierania typów reklamacji dla klienta");
    }

});

// definicja reducera
export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    setUserParams: (state, action) => {
      return {...state, ...action.payload}
    },
    setComplaintType:(state, action)=>{
      state.complaintType = action.payload;
    },

    updateCustomerData: (state, action) =>{
      const { type, ...updatedFields } = action.payload;
      return {
        ...state,
        ...updatedFields,
        type: {
          ...state.type,
          ...type,
        }}
      
      },
      setCustomerType: (state, action) => {
        const { id, displayName, customerType, description, value } = action.payload;
        state.type = {
            ...state.type,
            id: id !== undefined ? id : state.type.id,
            displayName: displayName !== undefined ? displayName : state.type.displayName,
            customerType: customerType !== undefined ? customerType : state.type.customerType,
            description: description !== undefined ? description : state.type.description,
            value: value !== undefined ? value : state.type.value,
        };
    },


    setNewCustomer: (state,action) =>{
      state.newCustomer = action.payload;
    }

   },
   extraReducers: {
 
    [getCustomer.fulfilled]: (state, action) => {
      state.type = action.payload;

    },
  }
});

export const { setUserParams, setComplaintType,updateCustomerData,setCustomerType,setNewCustomer } = customerSlice.actions;

export default customerSlice.reducer;